import * as Yup from 'yup';
import { hasPermission } from '../../hooks/usePermission';

export const bookingSchema = Yup.object().shape({
  samples: Yup.array().of(
    Yup.object().shape({
      test_type: Yup.string().required(),
      use_location_recommendation: Yup.boolean(),

      farm_name: Yup.string()
        .trim()
        .required('Required')
        .min(3, 'Too short'),

      farm_size: Yup.number().when('test_type', {
        is: 'SOIL',
        then: (s) =>
          s
            .required('Required')
            .min(0.01, 'Should be greater than 0')
            .max(499, 'Should be less than or equal to 499'),
        otherwise: (s) => s.notRequired(),
      }),

      farm_size_unit: Yup.string().when('test_type', {
        is: 'SOIL',
        then: (s) => s.required('Required'),
        otherwise: (s) => s.notRequired(),
      }),

      previous_crop: Yup.string().when('test_type', {
        is: 'SOIL',
        then: (s) =>
          s.trim().required('Required').min(2, 'Too short'),
        otherwise: (s) => s.notRequired(),
      }),

      next_crop: Yup.string().when('test_type', {
        is: 'SOIL',
        then: (s) =>
          s.required('Required').min(2, 'Too short'),
        otherwise: (s) => s.notRequired(),
      }),
      
      age: Yup.number().when('test_type', {
        is: 'SOIL',
        then: (s) =>
          s
            .transform((value, originalValue) =>
              originalValue === '' || originalValue === null ? 0 : value
            )
            .min(0, 'Age cannot be negative')
            .default(0),
        otherwise: (s) =>
          s
            .transform(() => 0)
            .default(0),
      }),

      sample_type: Yup.string()
        .trim()
        .required('Required'),

      comments: Yup.string().trim(),

      ...(hasPermission('bookings:treatment')
        ? {
            treatment: Yup.string().required('Required'),
          }
        : {}),

      ...(hasPermission('bookings:entity_id')
        ? {
            entity_id: Yup.string()
              .trim()
              .matches(
                /^[a-zA-Z0-9-]*$/,
                'Only alphanumeric characters and hyphens are allowed'
              ),
          }
        : {}),
    })
  ),
});
